import { component } from 'picoapp';
import Geolocation from 'utils/geolocation';

export default component((node) => {
  Geolocation(node);
});
